import { ClipboardList } from 'lucide-react';
import { APPLICATION_NOTE_TEMPLATES } from './applicationNoteTemplates';

type Props = {
  onApply: (body: string, mode: 'append' | 'replace') => void;
};

export function ApplicationNewTemplatesPanel({ onApply }: Props) {
  return (
    <div className="space-y-4">
      <p className="text-sm vscode-text-secondary">
        These templates populate <strong className="vscode-text-primary">internal notes</strong> only (not visible to the candidate).
        Use <strong className="vscode-text-primary">Append</strong> to stack multiple sections; <strong className="vscode-text-primary">Replace</strong> overwrites the whole box.
      </p>
      <div className="grid gap-3 sm:grid-cols-2">
        {APPLICATION_NOTE_TEMPLATES.map((t) => (
          <div
            key={t.id}
            className="rounded-xl border vscode-border bg-[color-mix(in_srgb,var(--vscode-bg-tertiary)_40%,transparent)] p-4 flex flex-col gap-3"
          >
            <div className="flex items-start gap-2">
              <ClipboardList className="h-5 w-5 text-brand-400 shrink-0 mt-0.5" />
              <div className="min-w-0">
                <p className="text-xs font-semibold uppercase tracking-wide vscode-text-tertiary">[{t.category}]</p>
                <p className="font-medium vscode-text-primary">{t.name}</p>
                <p className="text-xs vscode-text-tertiary mt-1">{t.description}</p>
              </div>
            </div>
            <pre className="text-[11px] vscode-text-tertiary max-h-28 overflow-y-auto whitespace-pre-wrap rounded-lg bg-black/25 p-2 border vscode-border">
              {t.body.slice(0, 220)}
              {t.body.length > 220 ? '…' : ''}
            </pre>
            <div className="flex flex-wrap gap-2 mt-auto">
              <button type="button" className="btn-secondary text-xs py-1.5" onClick={() => onApply(t.body, 'append')}>
                [Append to notes]
              </button>
              <button type="button" className="btn-secondary text-xs py-1.5" onClick={() => onApply(t.body, 'replace')}>
                [Replace notes]
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
